import {
	createRouter,
	createWebHistory
} from 'vue-router'
// import login from '../views/login.vue'
const login = () => import('../views/login/index.vue')
const ViewTracks = () => import('../views/view-tracks/index.vue')
const custMatchResults = () => import('../views/cust-match-results/index.vue')
const terminalStiing = () => import('../views/zhongduan-setting/index.vue')
const NewHand = () => import('../views/new-hand/index.vue')
const SportsStep = () => import('../views/sports-step/index.vue')
const screen = () => import('../views/screen/index.vue')
const oldMan = () => import('../views//old-man/index.vue')
const routes = [{
		path: '/login',
		name: 'login',
		component: login
	},
	{
		path: '/smartsh',
		name: 'oldMan',
		component: oldMan
	},
	{
		path: '/screen',
		name: 'screen',
		component: screen
	},
	{
		path: '/view-tracks',
		name: 'ViewTracks',
		component: ViewTracks,
	},
	{
		path: '/custMatchResults',
		name: 'custMatchResults',
		component: custMatchResults
	},
	{
		path: '/zhongduan-setting',
		name: 'terminalStiing',
		component: terminalStiing
	},
	{
		path: '/new-hand',
		name: 'NewHand',
		component: NewHand
	},
	{
		path: '/sports-step',
		name: 'SportsStep',
		component: SportsStep
	}
]

import store from '@/store';

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

const getToken = () => localStorage.getItem('token') || ''

router.beforeEach((to, from, next) => {
	const token = getToken()
	const isLoginPage = to.path === '/login'
	const isScreenPage = to.path === '/screen'

	if (isLoginPage || isScreenPage) {
		next()
		return
	}

	if (!to.name) {
		next({ path: `/login` })
		return
	}

	if (!token) {
		next({ path: `/login` })
		return
	}

	next()
})

export default router